import { render, staticRenderFns } from "./SubscribeBadge.vue?vue&type=template&id=07798066&scoped=true"
import script from "./SubscribeBadge.vue?vue&type=script&lang=js"
export * from "./SubscribeBadge.vue?vue&type=script&lang=js"
import style0 from "./SubscribeBadge.vue?vue&type=style&index=0&id=07798066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07798066",
  null
  
)

export default component.exports